var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThunderStorm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.0419 98.053V85.916H67.833C66.5183 85.916 65.632 84.5752 66.1502 83.3695L74.2254 64.574C74.6301 63.6296 76.0419 63.9182 76.0419 64.9467V78.609H84.1665C85.5032 78.609 86.3895 79.99 85.8291 81.2012L77.8492 98.4494C77.4244 99.3701 76.0419 99.0668 76.0419 98.053Z",
    fill: "url(#paint0_linear_184103_183581)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0005 24.5C84.173 24.5 83.358 24.545 82.5505 24.6225C76.853 16.975 67.7705 12 57.5005 12C43.218 12 31.2005 21.5925 27.4705 34.6775C17.623 35.9225 10.0005 44.3125 10.0005 54.5C10.0005 65.545 18.9555 74.5 30.0005 74.5C34.5455 74.5 80.268 74.5 85.0005 74.5C98.808 74.5 110 63.3075 110 49.5C110 35.6925 98.808 24.5 85.0005 24.5Z",
    fill: "url(#paint1_linear_184103_183581)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 85.6031V68.9931H38.7926C36.9976 68.9931 35.7876 67.1581 36.4951 65.5081L47.5201 39.7856C48.0726 38.4931 50.0001 38.8881 50.0001 40.2956V58.9931H61.0926C62.9176 58.9931 64.1276 60.8831 63.3626 62.5406L52.4676 86.1456C51.8876 87.4056 50.0001 86.9906 50.0001 85.6031Z",
    fill: "url(#paint2_linear_184103_183581)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184103_183581",
    x1: 66.6425,
    y1: 65.1244,
    x2: 94.9281,
    y2: 95.9044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_184103_183581",
    x1: 53.283,
    y1: 12.1975,
    x2: 64.0455,
    y2: 75.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.482325,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_184103_183581",
    x1: 37.1672,
    y1: 40.5388,
    x2: 75.885,
    y2: 82.5708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36001"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderStorm);
export default __webpack_public_path__ + "static/media/thunder-storm.0b80226ae83b7eba1ae727e23ad9276b.svg";
export { ForwardRef as ReactComponent };